module.exports = __webpack_public_path__ + "img/602.a8186000.jpg";